The details of the conflicting candidate.
